<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12">
                <h2 class="page-title">Detalhes da Entidade</h2>
                <p class="page-subtitle">Configurações globais do sistema</p>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">
            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            Configurações do Sistema
                            <ion-badge [color]="item?.PayshopApplicationStatus === 0 ? 'warning' : 'success'">
                                {{ getPayshopStatusName(item?.PayshopApplicationStatus) }}
                            </ion-badge>
                        </ion-card-title>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="information-circle-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">ID</span>
                                    <span class="detail-value">{{ item?.Id }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado em</span>
                                    <span class="detail-value">{{ item?.CreateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Criado por</span>
                                    <span class="detail-value">{{ item?.CreateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid" *ngIf="item?.UpdateDate">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado em</span>
                                    <span class="detail-value">{{ item?.UpdateDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="person-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Atualizado por</span>
                                    <span class="detail-value">{{ item?.UpdateUser }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações do Payshop -->
                        <ion-item-divider>
                            <ion-label>Configurações do Payshop</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="document-text-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">NIF do Payshop</span>
                                    <span class="detail-value">{{ item?.PayshopVatNumber }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="wallet-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Número de Conta Bancária</span>
                                    <span class="detail-value">{{ item?.PayshopBankAccountNumber }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de OCR -->
                        <ion-item-divider>
                            <ion-label>Configurações de OCR</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="scan-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Interações Totais</span>
                                    <span class="detail-value">{{ item?.OCRTotalItemsInteraction }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="cloud-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Limite Mensal Google Vision</span>
                                    <span class="detail-value">{{ item?.OCRGoogleCloudVisionLimitItemsMonth }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.OCRGoogleCloudVisionMode ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.OCRGoogleCloudVisionMode"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Modo Google Cloud Vision</span>
                                    <span class="detail-value">{{ item?.OCRGoogleCloudVisionMode ? 'Ativo' : 'Inativo' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.OCRTesseractMode ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.OCRTesseractMode"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Modo Tesseract</span>
                                    <span class="detail-value">{{ item?.OCRTesseractMode ? 'Ativo' : 'Inativo' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon name="shield-checkmark-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Precisão Mínima do Ficheiro</span>
                                    <span class="detail-value">{{ item?.OCRFileAccuranceMinimum }}%</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Candidaturas -->
                        <ion-item-divider>
                            <ion-label>Configurações de Candidaturas</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-number-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Dias para Reclamação</span>
                                    <span class="detail-value">{{ item?.DaysToAppealInvoiceDiscount }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="cash-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Permitir Carregar Saldo da Carteira</span>
                                    <span class="detail-value">{{ item?.AllowLoadWalletBalance ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Início das Candidaturas</span>
                                    <span class="detail-value">{{ item?.ApplicationSubmissionStartDate | date:'medium' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="calendar-clear-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Fim das Candidaturas</span>
                                    <span class="detail-value">{{ item?.ApplicationSubmissionEndDate | date:'medium' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid single-col" *ngIf="item?.ApplicationSubmissionDescription">
                            <div class="detail-item">
                                <ion-icon name="document-text-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Descrição das Candidaturas</span>
                                    <span class="detail-value">{{ item?.ApplicationSubmissionDescription }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Processamento -->
                        <ion-item-divider>
                            <ion-label>Configurações de Processamento</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid single-col">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.ProcessAllBenefitsTogetherAfterFinishConsumptionsImport ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.ProcessAllBenefitsTogetherAfterFinishConsumptionsImport"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Processar Todos os Benefícios Juntos</span>
                                    <span class="detail-value">{{ item?.ProcessAllBenefitsTogetherAfterFinishConsumptionsImport ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="document-attach-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Tamanho Máximo do Ficheiro</span>
                                    <span class="detail-value">{{ formatFileSize(item?.MaximumBytesFileSize) }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="mail-unread-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Email BCC para Lista de Comerciantes</span>
                                    <span class="detail-value">{{ item?.MerchantListEmailBCC || 'Não configurado' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações do Cartão da Carteira -->
                        <ion-item-divider>
                            <ion-label>Configurações do Cartão da Carteira</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon name="calendar-number-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Validade em Meses</span>
                                    <span class="detail-value">{{ item?.WalletCardValidityInMonths }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon name="calendar-outline"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Validade em Anos</span>
                                    <span class="detail-value">{{ item?.WalletCardValidityInYears }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Faturação -->
                        <ion-item-divider>
                            <ion-label>Configurações de Faturação</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.AllowInvoiceRegistWithUnknownVatNumber ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.AllowInvoiceRegistWithUnknownVatNumber"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Permitir Faturas com NIF Desconhecido</span>
                                    <span class="detail-value">{{ item?.AllowInvoiceRegistWithUnknownVatNumber ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.DisableVerifyInvoiceATCUD ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.DisableVerifyInvoiceATCUD"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Desativar Verificação ATCUD</span>
                                    <span class="detail-value">{{ item?.DisableVerifyInvoiceATCUD ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Configurações de Menores -->
                        <ion-item-divider>
                            <ion-label>Configurações de Menores</ion-label>
                        </ion-item-divider>

                        <div class="detail-grid">
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.HideUnderAgeHouseHoldMemberInfoForRegistListing ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.HideUnderAgeHouseHoldMemberInfoForRegistListing"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Ocultar Informações de Menores</span>
                                    <span class="detail-value">{{ item?.HideUnderAgeHouseHoldMemberInfoForRegistListing ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                            <div class="detail-item">
                                <ion-icon
                                    [name]="item?.VerifyUnderAge ? 'checkmark-circle-outline' : 'close-circle-outline'"
                                    [class.status-on]="item?.VerifyUnderAge"></ion-icon>
                                <div class="detail-text">
                                    <span class="detail-label">Verificar Menores</span>
                                    <span class="detail-value">{{ item?.VerifyUnderAge ? 'Sim' : 'Não' }}</span>
                                </div>
                            </div>
                        </div>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>
